export var generateRequestID = function generateRequestID() {
  var length = 6;
  var allowedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var text = '';

  for (var i = 0; i < length; i++) {
    text += allowedChars.charAt(Math.floor(Math.random() * allowedChars.length));
  }

  return text;
};
export var getSwicusWebAppUrl = function getSwicusWebAppUrl(environment) {
  return environment === 'production' ? 'https://my.solarwinds.cloud' : 'https://st-my.solarwinds.cloud';
};
export function assertResponseSuccess(response) {
  if (!response.ok) {
    throw new Error("Expected status was OK (200-299) but got ".concat(response.status));
  }
}